import axios from '@/request'

export default{
    get_lightlist(data = {}){
        return axios({
            url:'/lottery/lottery/hunanribaoLightList',
            method:'post',
            data
        })
    },
    lightup(data = {}){
        return axios({
            url:'/lottery/lottery/hunanribaoLightUp',
            method:'post',
            data
        })
    },
    get_lucknum(data = {}){
        return axios({
            url:'/lottery/lottery/getoppnums ',
            method:'post',
            data
        })
    }
}